(function ($) {
  $(document).ready(function () {
    $('.card-grid .card .text-wrap h3').matchHeight();
    const editor = document.querySelector('.text-editor');
      const heading = document.querySelector('.text-editor .wrapper h1');

      if (heading && editor) {
        const text = heading.textContent.trim();

        if (
          text === "Terms & Conditions" ||
          text === "Privacy Policy"
        ) {
          editor.classList.add('news-detail');
        }
      }

      document.querySelectorAll('p, h1, h2, h3, h4, h5, h6').forEach(el => {
        el.innerHTML = el.innerHTML.replace(/CO2/g, 'CO<sub>2</sub>');
      });
  });
})(jQuery);